/**
 * 全角カナかどうか検証する
 * https://ja.wikipedia.org/wiki/Unicode一覧_3000-3FFF
 */
const full_width_kana: any = {
  validate: (value: any): boolean => {
    if (Array.isArray(value)) {
      return value.every((v: any) => full_width_kana.validate(v));
    }
    if (value == null || value === '') {
      return true;
    }
    if (typeof value !== 'string') {
      return false;
    }
    return Array.prototype.every.call(value, full_width_kana.contains);
  },
  contains: (c: string): boolean => {
    return (c >= 'ァ' && c <= 'ヺ') || c === 'ー';
  }
};
export default full_width_kana;
